export default __webpack_public_path__ + "static/media/user_0.5459f47d.svg";